export default {
  globalCancel: 'Cancel',
  globalSelect: 'Select',
  globalDelete: 'Delete',
  globalAdd: 'Add',
  globalUploadPhoto: 'Upload Image',
  globalSubmit: 'Submit',
  globalNoData: 'No Data Available to Display !',
  globalLoadMore: 'More...',
  chargeBalancePage: {
    choosePaymentCard: 'Choose Card',
    title: 'Balance Charge',
    amount: 'Amount',
    charge: 'Charge my Balance',
    applePay: {
      updateApp: 'Please update the app to use Apple Pay',
      deviceMissingSupport: 'This device does not support Apple Pay',
      deviceMissingUpdates: 'This device needs updates to for Apple Pay to work',
      deviceMissingConfig:
        'This device needs adding payment-methods or changing preferences for Apple Pay to work'
    }
  },
  chargeBalanceOptions: {
    title: 'Charge balance options',
    voucher: 'Voucher or recharge card',
    fawry: 'Fawry egyptian payment-service',
    tamara: 'Tamara',
    registrationMessage:
      'To complete your driver registration, you must charge your wallet with a minimum of {amount} {currency}'
  },
  chargeBalanceUsingFawryPage: {
    title: 'Balance Charge (Fawry Egyptian Payment-Service)',
    amount: 'Amount',
    charge: 'Charge my Balance',
    referenceNumber: 'Reference number',
    pleasePay: 'Please pay the invoice with the reference number shown through the Fawry service.'
  },
  chargeBalanceUsingVoucherPage: {
    title: 'Balance Charge (Using Voucher)',
    voucherCode: 'Voucher code',
    charge: 'Charge my Balance',
    successMessage: 'Balance charged successfully'
  },
  paymentMethodsPage: {
    title: 'Payment Methods',
    cardType: 'Card type',
    cardNumber: 'Card number',
    deletionConfirmation: {
      title: 'Card deletion',
      content: 'Ary you sure you want delete this card',
      successMessage: 'Card deleted successfully'
    },
    addPaymentMethod: {
      title: 'Add Card',
      choosePaymentOption: 'Choose Card Type'
    }
  },
  ticketPage: {
    sendComment: 'Send',
    ticketClosed: 'This Issue Solved Successfully',
    addYourMessage: 'Type your message...',
    newCommentAddedMessage: 'New Message Added Successfully'
  },
  userProfile: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone Number',
    password: 'Password',
    copiedMessage: 'Text copied to clipboard!',
    referralCode: 'Referral code',
    appLinkIos: 'IOS application download link',
    appLinkAndroid: 'Android application download link',
    editBasicInfo: {
      title: 'Edit user information',
      message: 'Information updated successfully'
    },
    uploadProfileImage: {
      message: 'Profile image updated successfully'
    },
    changePhone: {
      title: 'Change phone number',
      message: 'Phone number changed successfully',
      stepOne: {
        title: 'First step',
        enterPassword: 'Please Enter your current password',
        confirm: 'Confirm'
      },
      stepTwo: {
        title: 'Second step',
        enterPhone: 'Please Enter your New Phone Number',
        continue: 'Continue'
      },
      lastStep: {
        title: 'Last step',
        enterOtp: 'Please Enter 4-digits code sent to your WhatsApp',
        resendOtp: 'Resend code again',
        toResend: 'Seconds to resend code',
        otpSent: 'Code with 4-digits sent to your WhatsApp',
        confirm: 'Confirm'
      }
    },
    changePassword: {
      title: 'Change password',
      message: 'Password changed successfully',
      oldPassword: 'Current password',
      newPassword: 'New password',
      newPasswordConfirmation: 'New password confirmation'
    }
  },
  driverAccount: {
    title: 'My account',
    driverProfile: 'Account Information',
    vehicleInfo: 'Vehicle information',
    setting: 'Settings',
    help: 'Help'
  },
  driverVehicle: {
    category: 'Category',
    plate: 'Plate',
    manufacturer: 'Manufacturer',
    model: 'Model'
  },
  driverSettings: {
    receiveAllTrips: 'Receive all ride categories',
    language: 'Language',
    logout: 'Logout',
    deleteAccount: 'Delete account',
    successMessage: 'Settings changed successfully',
    deleteAccountHeader: 'We are sorry to hear you want to delete your account',
    deleteAccountP1:
      'If you are having any problem with your account, we can most likely help you resolve it. please',
    deleteAccountSupport: 'visit our help center',
    deleteAccountP2:
      'Are you sure you want to delete your account? If you continue, your account details will be deleted.'
  },
  driverEarning: {
    title: 'earning'
  },
  clientWallet: {
    title: 'Wallet'
  },
  tickets: {
    title: 'help requests',
    createIssue: 'Report an issue'
  },
  helpOptions: {
    title: 'help options'
  },
  driverRideDetails: {
    createRideIssue: 'Report a ride issue',
    rideInfo: 'Ride details',
    fareInfo: 'Fare details',
    time: 'Date',
    category: 'Category',
    startAddress: 'Pickup address',
    endAddress: 'Drop-off address'
  },
  ClientRidesHistory: {
    title: 'Rides History',
    createRideIssue: 'Report a ride issue',
    time: 'Date',
    startAddress: 'Pickup address',
    endAddress: 'Drop-off address'
  },
  clientSettings: {
    beDriver: 'Become a driver',
    termAndCondition: 'Terms & Conditions',
    privacy: 'Privacy Policy',
    language: 'Language',
    logout: 'Logout',
    deleteAccount: 'Delete account',
    successMessage: 'Settings changed successfully',
    deleteAccountHeader: 'We are sorry to hear you want to delete your account',
    deleteAccountP1:
      'If you are having any problem with your account, we can most likely help you resolve it. please',
    deleteAccountSupport: 'visit our help center',
    deleteAccountP2:
      'Are you sure you want to delete your account? If you continue, your account details will be deleted.'
  },
  clientPromotions: {
    enterCode: 'Enter your promo code here',
    apply: 'Apply'
  },
  userLogin: {
    enterPhone: 'Enter your phone number',
    enterPassword: 'Enter your password',
    forgetPassword: 'Forget your password',
    continue: 'Continue',
    otpSent: 'A four-digit code has been sent to your WhatsApp',
    enterOtp: 'Please enter the 4 digits sent to your WhatsApp',
    resendOtp: 'Resend the code',
    toResend: 'Seconds to resend the code',
    resetPassword: 'Reset password',
    newPassword: 'New password',
    newPasswordConfirmation: 'Confirm new password',
    resetPasswordMessage: 'The password has been successfully reset'
  },
  driverRegistration: {
    fillPersonalInfo: 'Add your personal information to complete the registration',
    continue: 'Continue',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    nationality: 'Nationality',
    city: 'City',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
    referredBy: 'Referral Code (Optional)',
    successMessage: 'Personal information has been saved successfully',
    uploadImages: 'Please upload all required documents',
    imageUploadedSuccessfully: 'Image uploaded successfully',
    areYouOwner: 'Are you the owner of the vehicle?',
    registeredSuccessfully: 'Registered successfully',
    thanksForRegistration: 'Thank you for completing the registration process',
    weWillReview: 'Your account is now under review, and we will contact you as soon as possible',
    refresh: 'Refresh',
    agreeCondition: 'By registering with Ego, you agree to'
  },
  clientRegistration: {
    fillPersonalInfo: 'Add your personal information to complete the registration',
    continue: 'Continue',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
    referredBy: 'Referral Code (Optional)',
    successMessage: 'Personal information has been saved successfully',
    agreeCondition: 'By registering with Ego, you agree to'
  },
  issue: {
    createIssue: 'Report an issue',
    photo: 'image',
    phoneNumber: 'Phone Number',
    fillAllFields: 'Please fill all required fields',
    additionalInfo: 'Additional Info',
    driverDeleteAccountTitle: 'Delete my account',
    driverDeleteAccountText:
      'If you wish to stop driving with us. Please let us know by filling this form and we will make sure we remove your details.',
    questionOtherTitle: 'I have a different query about Ego',
    questionOtherText:
      "If you have a query that is not listed in the previous options. Please contact us by filling this form and we'd be more than happy to assist you.",
    cancellationFeeMissingTitle: 'I want to request a cancellation fee',
    cancellationFeeMissingText:
      "If your passenger canceled a trip and you didn't receive your cancellation fee that you believe they should have been charged for. We're ready to check this for you. Please fill in this form and you will be contacted.",
    cashNotRightTitle: "I couldn't collect the correct amount of cash\t",
    cashNotRightText:
      "If for any reason you couldn't collect the complete amount of cash from the passenger after finishing the trip. Kindly fill in this form and we will surely investigate this case further.",
    cashCollected: 'Cash Collected From Rider',
    driverAccidentTitle: 'I want to report an accident',
    driverAccidentText:
      "At Ego, nothing is more important than our passengers and drivers safety. If you were involved in an accident, our first priority is your health and well-being. So make sure you're safe by contacting the police and the ambulance if necessary. Please don't forget to report to us immediately and we will get back to you shortly.",
    dateOfAccident: 'Date of accident',
    timeOfAccident: 'Time of accident',
    locationOfAccident: 'Location of accident',
    inVehicle: 'Were You In the Vehicle',
    isInjured: 'Were You Injured',
    accidentPhoto: 'Accident photo',
    policeReport: 'Police Report',
    isDamaged: 'Was Your Vehicle Damaged',
    fareAdjustedTitle: 'I want to dispute an earning modification\t',
    fareAdjustedText:
      "One of the common reasons why your earnings might be adjusted is that your passenger might have reached out to us and complained about the trip. If you were notified that some earning modifications were applied to your fare and you'd like to dispute it, please make sure to contact us through this form. We will review the fare, and get back to you shortly.",
    foundItemTitle: 'Help the passenger claim the lost item',
    foundItemText:
      "If you recognized a lost item after one of your trips. We highly recommend that you contact the passenger immediately to make sure they claim it as soon as possible. If you tried to contact the passenger, but you don't seem to reach him/her. Don't worry we will take care of this. Just make sure you fill in this form and we'll get back to you shortly.",
    foundItemTime: 'When Did You Find The Item',
    foundItemRide: 'Do You Know Which Ride This Item Belongs To',
    phoneShare: 'Do You Want To Share Your Number With The Rider',
    itemPhoto: 'Item Photo',
    additionalInfoDeleteAccount: 'Tell us why',
    willBeInTouch: "We' received your message and will be in touch as soon as possible",
    clientPaymentOtherTitle: 'I have a different inquiry',
    clientPaymentOtherText:
      "If you have a payment query that is not covered in the previous options. Please contact us by filling this form and we'd be more than happy to assist you.",
    yourInquiry: 'Your Inquiry?',
    duplicateChargeTitle: 'I was charged twice for the same trip',
    duplicateChargeText:
      'If you were charged twice for the same ride or you discover any other incorrect charges, notify us as soon as possible. Fill in this form and we will contact you shortly.',
    amount: 'Amount',
    firstCharge: 'Date of first charge',
    secondCharge: 'Date Of second charge',
    thirdCharge: 'Date of third charge',

    chooseOneOfOptions: 'Please Choose One Of Options',
    cancellationFeeOption1: "My driver and I couldn't Connect",
    cancellationFeeOption2: 'My pickup location was incorrect',
    cancellationFeeOption3: 'My driver cancelled',
    cancellationFeeOption4: 'The ETA was too long',
    cancellationFeeOption5: 'The ETA was too short',
    cancellationFeeOption6: 'My driver asked me to cancel',
    cancellationFeeOption7: 'Other',
    other: 'Other',
    clientCancellationFeeTitle: 'Dispute a cancellation fee',
    clientCancellationFeeText:
      "If you canceled a trip and got charged a cancellation fee that you believe you shouldn't have been credited for. We're ready to check this for you. Please fill in this form and you will be contacted.",
    dangerousDriverTitle: 'The driver made me feel threatened',
    dangerousDriverText:
      "Nothing is more important than your safety and satisfaction. If by any means your driver made you feel threatened by driving fast, being rude or used abusive language. Please don't hesitate to report this to us. Ego takes this seriously and will take serious actions towards any inappropriate behaviors that might endanger our passengers.",
    driverNotMatchTitle: 'The driver info doesn’t match the one on my app',
    driverNotMatchText:
      "Before your trip starts, Ego will provide you with full details about the driver and the vehicle just to ensure your safety. If the driver's name, profile picture, vehicle's make and model or license plate was different than the one you were matched up with. We'd appreciate your support if you reported this so we can take immediate actions.",
    vehicleDetails: 'Vehicle color, make and model',
    driverMatch: 'Did you mention that to the driver',
    driverOtherTitle: 'I have a different complaint regarding the driver or vehicle',
    driverOtherText:
      "If you wish to complain about any inconvenience that you encountered during your last ride and it's not mentioned in the previous list. Please let us know and we'll be doing our investigations and we'll get back to you as soon as possible.",
    driverUnsafeTitle: 'The driver made me feel threatened',
    driverUnsafeText:
      "Nothing is more important than your safety and satisfaction. If by any means your driver made you feel threatened by driving fast, being rude or used abusive language. Please don't hesitate to report this to us. Ego takes this seriously and will take serious actions towards any inappropriate behaviors that might endanger our passengers.",
    lostItemTitle: 'How can I retrieve an item I lost during the ride',
    lostItemText:
      'If you lost an item. We highly recommend that you contact the driver immediately to make sure you claim it straight away. In addition to reporting this to us so we can keep track of the item until you receive it. Please note if you lost your phone, provide us with an alternative number to be able to reach you easily.',
    itemDescription: 'Item type description',
    overChargedCashTitle: 'Dispute an overcharge',
    overChargedCashText:
      "If your ride charged you more than expected and you're suspecting that something is wrong with the fare or the receipt. Please contact us immediately. Rest assured we're going to view your ride immediately. Make all necessary calculations and get in touch with you as soon as possible.",
    cashExpected: 'Cash fare I expected',
    cashAsked: 'Cash fare my driver asked me to pay',
    cashPaid: 'Cash fare I paid to my driver',
    pickupIssueTitle: 'The driver had trouble picking me up',
    pickupIssueText:
      'We ensure you go on the fastest, easiest and safest rides. If it took longer than usual for the driver to pick you up or had lots of trouble connecting with the driver for the pickup. You can let us know by filling this form and we will be looking into this for you.',
    poorRouteTitle: 'The ride took longer than expected',
    poorRouteText:
      'If you believe that the ride took longer than expected as a result of a longer route or your driver ignored your preferred route on purpose. Please report this to us by filling this form, we will consider adjusting your balance if it was an intended incident.',
    poorRouteOption1: 'The route was longer than necessary',
    poorRouteOption2: 'The driver took a wrong turn and got lost',
    poorRouteOption3: "The driver didn't follow my Directions",
    poorRouteOption4: 'We Encountered traffic or road construction',
    clientDeleteAccountTitle: 'Delete my account',
    clientDeleteAccountText:
      'If you choose to delete your Ego account, we can sadly, help you by filling this form and it will be permanently deactivated after 30 days.',
    drawEarningsTitle: 'Draw my earnings',
    drawEarningsText:
      'The minimum amount you can withdraw is 30 riyals and the highest amount is 100 riyals',
    drawEarningsWarning: 'Recharge balance and offers are non-refundable',
    idNumber: 'ID Number',
    stcPayPhoneNumber: 'Stc Pay Phone Number',
    refundRequestTitle: 'Refund Request',
    refundRequestText:
      'In case you want to get a refund the balance in your wallet by requesting a trip, fill out this form and you will receive it soon',
    refundRequestWarning: 'Recharge balance and offers are non-refundable',
    updatePersonalDocumentsTitle: 'Update personal documents',
    updatePersonalDocumentsText: 'you can use the form below to update your personal information',
    updateVehicleDocumentsTitle: 'Update vehicle documents',
    updateVehicleDocumentsText:
      'For Your safety and the safety of passengers You can use the form below to request update or change in vehicle information after entering the correct details',
    idPhoto: 'National ID photo',
    personalPhoto: 'Personal photo',
    licensePhoto: 'Driver license photo',
    registrationPhoto: 'Vehicle Registration photo',
    vehiclePhoto: 'Vehicle photo',
    delegationPhoto: 'Delegation photo in case if you non-ownership of the vehicle',
    insurancePhoto: 'Insurance photo'
  },
  termAndConditions: {
    termsTitle: 'Terms and Conditions',
    termsIntroduction: `These terms and conditions govern the accessibility and usage of individuals to all of EGO's platforms. it is a Saudi company with limited liability and was established at 2018 under the name of Ego Information Technology Company and its main office located in Riyadh`,
    termsDefinition: 'Definitions',
    termsPoint1Paragraph1:
      'EGO Company: The service provider and the point of communication between the driver and the passenger, and it was established in 2018 under the name of EGO Information Technology Company',
    termsPoint1Paragraph2: 'Website: https://ego-now.com',
    termsPoint1Paragraph3:
      ' Application: The digital platform providing the services to the driver and customer under name of EGO for customers and EGO Driver for drivers',
    termsPoint1Paragraph4:
      'Wallet: Each of the driver and customer has a separate portfolio in the applications, where they can add their funds, use it at their rides based on the applicable method by EGO.',
    termsPoint1Paragraph5:
      'Price: The variable value of the ride amount based to the type of vehicle.',
    termsPoint1Paragraph6:
      'Passengers (Customers):  Persons who request a mean of transportation through EGO application.',
    termsPoint1Paragraph7:
      'Individual persons who provide services to transport passengers from one place to another with their own vehicles after connecting them to the passengers through EGO application.',
    termsPoint2title: 'Contractual Relationship',
    termsPoint2Paragraph1:
      'Your access to the digital platforms (the website and applications) deemed your approval and a full compliance to the terms and conditions without exclusion, and in case of none approval, you must immediately stop using EGO platforms and stop benefiting from its services.',
    termsPoint2Paragraph2:
      'These Terms and Conditions also supersede any prior agreements entered into with you. EGO may modify them at any time at its sole discretion without prior notice. We encourage you to check them periodically from time to time. Your continuous usage of the services is considered as full approval and consent to the modifications on these terms and conditions.',
    termsPoint2Paragraph3:
      'You acknowledge that there is no business relationship between you and EGO. you acknowledge that there is no joint venture or partnership between you and EGO. You shall not act as an employee, or agent or representative of us. You shall not make any contractual relationship on behalf of EGO.',
    termsPoint3Title: 'Services',
    termsPoint3Paragraph:
      'EGO provides service of connecting the driver to the passenger in order to coordinate and schedule transportation services through the owned mobile applications under the name of EGO and EGO driver. EGO doesn’t provide transportation services. they are provided by the driver when the passenger requests a ride. you comply with the services according to a personal and none commercial use unless approved otherwise by EGO in a separate agreement with you.',
    termsPoint4Title: 'License',
    termsPoint4Paragraph:
      'Regarding your adherence to these conditions, EGO agrees to grant you the accessibility right to the application and services and irrevocable, limited and non-exclusive license, which cannot be licensed or transferred to others, and for personal and none commercial use. this license will be cancelled upon service cancellation.',
    termsPoint5Title: 'Restrictions',
    termsPoint5Paragraph: `You shall not have the right to delete or copy any copyright, intellectual property, registered and unregistered trademarks from any part of the service, or to copy, modify, distribute, rent, sell, publicly display, broadcast, otherwise exploit services, except what EGO permits. you aren’t entitled to
  Manipulate its codes, reverse its engineering or dismantling it or construct or cause to construct a tool for the purpose to get rid of any part of services or dele tot or explicit its details by other way, or handicap work or a duty of any parts of services or try to enter illegally to the services or destruction any of its sides or any relevant systems and networks
  EGO will do its best effort to ensure that the application is used only for drivers and passengers with integrity and respect. However, we do not ensure that each user fulfills the above criteria at all times.
  `,
    termsPoint6Title: ' Ownership',
    termsPoint6Paragraph:
      'The relevant services and rights remain the property of EGO. These conditions and the use of services shall not grant you any rights of services other than the granted limited license above, nor the use or reference in any way to the name of the company, logos, product and service names, trademarks or services of EGO.',
    termsPoint7Title: 'Monitoring Performance',
    termsPoint7Paragraph:
      'Your performance and compliance will be monitored from time to time by EGO employees or by a third party assigned by EGO Company. we may gather photos and documents during monitoring, and we may restrict your access to our platforms and suspend your account as a result of monitoring.',
    termsPoint8Title: 'Mail and text messages',
    termsPoint8Paragraph:
      'Upon creating an account, you agree that EGO may send you mail and text messages as part of the normal business context of your use of services. ',
    termsPoint9Title: ' Promotional codes',
    termsPoint9Paragraph: `
  The policy of offers and promo codes apply to all users. EGO may create promotional codes and shall be governed by any additional conditions identified on basis of each promo code. The validity of the promo codes in the application shall expire once the promo code is applied to your account and may be terminated earlier before that.
 You can only apply one promo code per ride, and it cannot be transferred to the next ride. The offer is applied once during its validity period, when you apply an offer e.i charging your wallet with a certain amount offered by EGO, then  getting additional credit specified by EGO, this extra amount is a balance in your wallet (the driver or passenger) and you can use it only on trips. It is not transferrable into cash to your Bank account. No amounts will be transferred to the driver's bank account except for profits on rides.
EGO may cancel any promotional code at any time and for any reason without incurring minimal responsibility. e.i  but is not limited to, using the promo codes illegally, fraudulently, or issued by default/expired.
  `,
    termsPoint10Title: 'Using Services',
    termsPoint10Paragraph: `
  A personal account must be created through registration in the application in order to benefit from services of EGO. You must be 18 years old at least and own a valid driving license, vehicle with your name. or to be authorize to drive it,  plate number, personal data name, address, age, mobile number, national identification image, valid payment method, and to own all necessary and valid licenses such as vehicle licenses, Istimara, vehicle insurance and all requirements imposed or may be imposed by EGO for completion registration.

  the age of the customer user (passenger) shall be at least 18 years in addition to the personal information such as name, address, age, phone number, and at least one valid method of payment.

  You comply to maintain accurate, and latest personal information in your account. violating may result your inability to access or use the of the services. You are responsible for all activities of your account.

  You agree to maintain the security and confidentiality of your account username and password at all times. You will only have one account, otherwise permitted by EGO.
  `,
    termsPoint10Paragraph2:
      'You comply not to submit any user content that is defamatory, obscene, unlawful or offensive, as determined by EGO in its sole discretion, whether or not such material is protected by law. EGO may review, monitor and remove user content at its sole discretion at any time and for any reason without prior notice. The user (driver and passenger) is obliged to maintain the confidentiality of their accounts, information, trip details and bills, and not to post any of them on social media platforms. violating this exposes you to legal accountability. This information shall be disclosed only if requested by the competent official authorities. Otherwise, it is confidential between the user and Ego.',
    termsPoint11Title: ' Share Account ',
    termsPoint11Paragraph: `Account sharing is only permitted with the consent of EGO.
  You must not allow any person to use your account, or share your personal information with others, including your username or password. the bank account should be in your name.
  `,
    termsPoint12Title: ' Guns Banning',
    termsPoint12Paragraph:
      'Drivers and Passengers and their companions, are prohibited to carry guns of any kind when they are on ride',
    termsPoint13Title: ' Car Seats',
    termsPoint13Point1Paragraph:
      'he driver and passenger must comply with the applicable regulations when accompany infants and young children. passenger will be responsible to provide a child seat when requesting a ride .',
    termsPoint14Title: 'Payment',
    termsPoint14Paragraph: `
  The fees for each ride will be collected separately, except the rides, which the customer delay to pay, their fees will be added to the next ride. The added balance to the portfolio, is none refundable and you can use it at any time..
  The driver's wallet shall be charged by a minimum of SR100 (One Hundred Riyal) then to be operated and you (the driver) are aware that the paid amount is none refundable, and you can run it by activating rides until the portfolio balance is finished. For the passenger, the credit added in your wallet is none refundable as well and you can use it until the balance is finished or – upon your request - transfer the balance to another user specified by you (the driver or passenger)
  You should provide EGO with at least one effective and valid method of payment, EGO, based to the appropriate status, may collect the imposed amounts, in addition to the imposed fines as a result of your delay of payment.
  EGO also sends you a detailed receipt of the ride to your registered email immediately after its completion.
  If refusal collection payable fees to EGO, the "pay card" may appear in EGO, the application will require you to choose a method of payment before requesting a ride, to collect the outstanding balance.
  .
  `,
    termsPoint14Point1Title: 'Suspending Some Fees',
    termsPoint14Point1Paragraph: `When a recent payment method is added to your EGO account or not used for several days, EGO will verify it by issuing a temporary hold to authorize the transaction. Temporary transaction authorization holds are small amounts of money that are never actually charged to your account. However, you may notice that one of these amounts is included in your account as an outstanding fee.
  At the beginning of the ride, EGO may temporality suspend the fees to approve the transaction in your method of payment for the ride. This will appear as " pending " in the payment method in your account. Upon completion of the ride, this pending will be transferred to as fees for the final ride.

  In case cancellation the ride, or if the total fee for the ride, is different from the paid fee on advance in the application, the original pending of the transaction will be cancelled to approve the transaction from the used payment method within a few of working days, according to the policy of your bank.
  `,
    termsPoint14Point2Title: 'Impose Charges ',
    termsPoint14Point2Paragraph1:
      'The "pending" charges may be reserved for the ride on advance, and will be cancelled from your account, and will not be imposed at all. We will issue payments of reservations costs of rides in advance to ensure better protection against the cases of fraud, which may occur as a result of illegal usage of cards. You may notice a reservation to cost of ride in advance, if you added a new payment method recently, or if you did not use EGO App for a long time. ',
    termsPoint14Point2Paragraph2:
      'It is possible that one of your friends or family members is using your Ego account.',
    termsPoint14Point2Paragraph3: 'You may have canceled a ride recently.',
    termsPoint14Point3Title: 'Reasons arise failure of completion ride request:',
    termsPoint14Point3Point1: '1- You may owe EGO a payable amount.',
    termsPoint14Point3Point2: '2- Update your payment method.',
    termsPoint14Point3Point3: '3- EGO services may not be available in your location.',
    termsPoint14Point3Point4: '4- Drivers are not available.',
    termsPoint14Point3Point5: '5- The email or mobile number have not been confirmed.',
    termsPoint14Point3Point6: '6- Update your personal information.  ',
    termsPoint15Title: ' Responsibility of Driver and Passenger',
    termsPoint15Paragraph1:
      'Both the driver of the vehicle and the customer should comply with the laws and regulations of EGO Information Technology Company, otherwise, fines and penalties will be imposed by EGO Information Technology Company.',
    termsPoint15Point1Title: 'Responsibility of Driver',
    termsPoint15Point1Point1:
      'A.	Indication all their documents when requested by the service controller or to whom is officially responsible for authority of control and investigation.',
    termsPoint15Point1Point2:
      'B.	Not enable others to drive their own car and operate it in the activity.    ',
    termsPoint15Point1Point3:
      'C.	The driver should not smoke or permit passengers to smoke inside the vehicle during existing rides.',
    termsPoint15Point1Point4:
      'D.	Compliance to the rules of road traffic based on the traffic law and its executive regulations.',
    termsPoint15Point1Point5: 'E.	Not loading bags and luggage in vehicle cabin.    ',
    termsPoint15Point1Point6:
      'F.	Ensure that the car is clean and equipped with all safety measures before starting the ride.',
    termsPoint15Point1Point7:
      'G.	Do not let passengers get in the car except from the side of the sidewalk designated for pedestrians on the roads',
    termsPoint15Point1Point8:
      'H.	Assistance disabled persons when getting in and out of the vehicle as much as possible.',
    termsPoint15Point1Point9:
      'I.	Paying attention to appearance and personal hygiene and taking into account the preservation of public taste.',
    termsPoint15Point1Point10: 'J.	Compliance to the public morals and good handling of passengers.',
    termsPoint15Point1Point11: 'K.	Not to violate the privacy of passengers in any way.  ',
    termsPoint15Point1Point12:
      'L.	Not to communicate with passengers after the ride at all, except in the case of coordinating the delivery of lost items.',
    termsPoint15Point1Point13: 'M.	Any other obligations identified by EGO.',
    termsPoint15Point1Point14:
      "Breaching the responsibilities of the driver, shall put you under accountability and imposed fines and penalties according to EGO's internal regulations.",
    termsPoint15Point1Point15:
      "And you should be aware that violating the leader's responsibilities will subject you to accountability, fines, and penalties in accordance with Ego's internal regulations.",
    termsPoint15Point2Title: ' Responsibility of the passenger',
    termsPoint15Point2Point1: 'A.	Good behavior and public morals.  ',
    termsPoint15Point2Point2: "B.	Maintaining the driver's vehicle clean.",
    termsPoint15Point2Point3: 'C.	pay the ride amounts owed by you.',
    termsPoint15Point2Point4:
      'D.	Ensure that no personal belongings are forgotten before getting off the vehicle.',
    termsPoint15Point2Point5: 'E.	Any other obligations specified by EGO.',
    termsPoint15Point2Point6:
      'F.	Refraining from smoking of all kinds in the vehicle during existing rides.',
    termsPoint15Point2Point7:
      "G.	Breaching the responsibilities of the driver, put you under accountability and imposed fines and penalties according to EGO's internal regulations.",
    termsPoint15Point2Point8: '',
    termsPoint16Title: 'Pricing',
    termsPoint16Paragraph:
      'The basic fee of EGO may vary according to the type of registered vehicle to the driver and divided as follows: the price of kilos as a lump sum within the ride,  the price of the calculated minute during the ride, the price of roads and gates charges if any, airport surcharges if any, governmental charges, tax charges, prior fees to the customer or driver if any, compensation fees if any, fees of rush hour if any, deductions of EGO if any, fees of rate of EGO. EGO may modify any applicable pricing conditions from time to time without providing you any notice',
    termsPoint17Title: 'Termination',
    termsPoint17Paragraph1:
      "EGO may terminate the agreement immediately and stop your access to its platforms without prior notice, in case of violation of any of the terms of this agreement, or any applicable laws or regulations, or infringement and abuse of the reputation of EGO and its customers (passengers). Its directors, and employees across from social media or causing damage to EGO brand, or its reputation or business as identified by EGO based to its discretion. In the above-mentioned cases, we may prevent you from registering a new driver's account and imposing fines and penalties in accordance with the EGO domestic regulations, which are not inconsistent with the regulations in force.    ",
    termsPoint17Paragraph2:
      'We also may ban your access to EGO applications for the period of investigation, if we suspect a violation of the agreement or fraudulent activity on your part. The accessibility ban will be removed once the investigation denies suspicions.',
    termsPoint17Paragraph3: '',
    termsPoint17Paragraph4: '',
    termsPoint18Title: 'compensation',
    termsPoint18Paragraph:
      "You agree to indemnify and discharge EGO and its officers, directors and employees from all claims, losses, liabilities and expenses (including attorneys' fees) arising out of and in connection with your usage of the services or your violation of any of these terms.",
    termsPoint19Title: 'Responsibility',
    termsPoint19Paragraph:
      'EGO disclaims its responsibility towards all express, whether they are implied or statutory declarations and warranties which are not expressly in these terms, including the implied or legislated declarations regarding the merchantability, fitness for a particular purpose and non-infringement. In addition, EGO makes no declarations, warranties or guarantees regarding the reliability, accuracy of schedules, quality, suitability, or availability of the services or any of them, or about the suspension of the Services, as well as you understand that the operation of the application may be restricted by occasional technical errors and we cannot guarantee that the application will be operated at all times, hence EGO does not guarantee the quality, suitability, safety and ability of the third party providers. You agree that the entire risk arising from your usage of the services in connection with such usage, shall remain with you alone.',
    termsPoint20Title: 'Governing Law',
    termsPoint20Paragraph:
      'Except as provided in these terms, these terms shall be governed by and construed in accordance with the regulations of Saudi Arabia. Any dispute arising out of or relating to this agreement shall be subject to the Saudi judiciary.'
  },
  privacy: {
    privacyTitle: 'Privacy Policy ',
    privacyParagraph:
      'The Privacy Policy governs the applied approach of Ego Company in gathering, using, maintaining and certifying the gathered information by users of the platform of Ego. this privacy policy shall be applied to all of the digital platforms of Ego.    ',
    privacyPoint1Title: 'Information of Personal Identity:',
    privacyPoint1Paragraph:
      ' Ego gathers information of the personal identity by various methods, for example but not limited to times of visiting the platform, filling application of registration in Ego platform, questionnaire analysis form, and other activities, services, features, and available services we provide at our platform. the users are required to mention full name, email address, phone number, and the details of credit card.',
    privacyPoint2Title: 'Information doesn’t belong to the personal Identity',
    privacyPoint2Paragraph:
      'Ego gathers some information about users when they interact with the platform, and this information doesn’t belong to the personal identity, but it may include the type of smartphone, location and technical information of the communication means of the user to the platform,  such as the company which providing internet service and other similar information.',
    privacyPoint3Title: 'How we use the gathered information: ',
    privacyPoint3Paragraph:
      'Ego gathers and use the personal information of users at the following purposes:',
    privacyPoint3Point2Title: 'Improvement the quality of customer service',
    privacyPoint3Point2Paragraph:
      ' Your information enables us to fulfillment easily to your addressable orders to the customer service and your needs to support effectively',
    privacyPoint3Point3Title: 'Sending electronic messages regularly',
    privacyPoint3Point3Paragraph:
      'The registered email address by users, shall be used to deal with their order and shall be used only at sending information and relevant updates to their order. it may be used to response inquiries and other demands and questions. If the users wish to join the list of our correspondences, they will receive massages to their email including news of Ego, latest updates, relevant information of the template, details of trips, and if the users wish at any time to cancel the registration of receiving any future messages, we will provide them with instructions regarding the cancellation of registration at end of every sent message to their email, or the user may contact us through the template or our website.',
    privacyPoint3Point4Title: '',
    privacyPoint3Point4Paragraph: '',
    privacyPoint4Title: 'How we protect your information:',
    privacyPoint4Paragraph:
      'We apply procedures and security criteria in gathering, maintaining and dealing with your information, to protect this information from unauthorized dealing, or amendment, or disclosing or deleting of your personal details, name of user, password, and relevant information of you, stored details at our platform. Sensitive and private details are exchanged between Ego and its users through secured communication channels and will be coded and protected by certified digital methods and means.',
    privacyPoint5Title: 'Share Personal Details:',
    privacyPoint5Paragraph:
      'At Ego we do not sell, trade, or rent the details of the personal identity of the users to other parties, and we may share the generated gathered demographic information that have no link with any information of the personal identity of the visitors and users with our company, and affiliated companies, and who are identified for the above mentioned purposes. We may use other provider third party to enable us to facilitate our business, as well as at the duty of the platform or at manage the activities on our behalf, such as sending newsletters or surveys. We may share your details with this third party within the limits of those purposes. Your personal details shall be shared for security reasons upon request from the competent authorities in the Kingdom of Saudi Arabia.',
    privacyPoint6Title: 'Websites of Third Party:',
    privacyPoint6Paragraph:
      'Users may find advertisements or other content on our Platform which related the websites and services of our partners, suppliers, advertisers, sponsors, licensors, or other directions representing the third party. We do not control the appeared content at these websites, and we are not responsible for the practices of the related websites to our websites. However, those websites or services, with full contents and links, may be changed periodically. As well as the websites and services have privacy policy and policies of customers service. As well as the disclosure and interaction to any other website, such as websites holding a link to our website, is governed by the conditions and policies of these websites.',
    privacyPoint7Title: 'Changes of privacy policy:',
    privacyPoint7Paragraph:
      'Ego may update the privacy policy at any time without a prior notice. We advise you to check the date of the update at the bottom of this page. we may send a message to the email. Accordingly, we encourage the users to check the privacy policy frequently to recognize any changes to be on full awareness regarding our procedures for protection the personal details we gather. the user agrees that the continuous access to services, deemed their approval of these updates and responsibility to review the privacy policy periodically.',
    privacyPoint8Title: 'Approval the privacy policy:',
    privacyPoint8Paragraph:
      'By using the Ego Platforms, you agree to our privacy policy and the terms and conditions that govern the use of our website and applications. If you do not agree to this policy, you should not use our Platforms. If you do not approve this policy, you should not use our platforms. you acknowledge that your continuous usage and accessibility to it after declaring the changes of this policy, deemed your approval to these changes.',
    privacyPoint9Title: 'Contact Us:',
    privacyPoint9Paragraph:
      'If you have more questions regarding this Privacy Policy, or your dealings with the Platform, you may contact us at'
  }
}
